import React from 'react';
import { Checkbox as BaseCheckbox, FormControlLabel } from '@material-ui/core';
import PropTypes from 'prop-types';

const Checkbox = (props) => {
  return (
    <FormControlLabel
      classes={props.classesLabel}
      control={
        <BaseCheckbox
          id={props.id}
          name={props.name}
          checked={props.checked}
          value={props.value}
          variant={props.variant}
          {...props.field}
          onChange={props.onChange}
        />
      }
      label={props.label}
    />
  );
};

Checkbox.propTypes = {
  classesLabel: PropTypes.object,
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.node,
  checked: PropTypes.bool,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  field: PropTypes.object, // alternative props object (use for formik field)
};

export default Checkbox;
